@if (loading) {
  <div class="showbox" [@enterAnimation]>
    <div class="loader path">
      <app-lu-icon class="circular" icon="spinner"></app-lu-icon>
    </div>
  </div>
}
